export function ReduxAction(type, slice) {
    return function decorator(constructor) {
        return class extends constructor {
            constructor() {
                super(...arguments);
                this.type = type;
                this.slice = slice;
            }
        };
    };
}
